import { render, staticRenderFns } from "./editPositive.vue?vue&type=template&id=d2caf2cc&scoped=true"
import script from "./editPositive.vue?vue&type=script&lang=js"
export * from "./editPositive.vue?vue&type=script&lang=js"
import style0 from "./editPositive.vue?vue&type=style&index=0&id=d2caf2cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2caf2cc",
  null
  
)

export default component.exports